"use client";

import { useTranslations } from "next-intl";
import { useIntlRouter } from "@/lib/utils/navigation";

export default function BackButton() {
  const router = useIntlRouter();
  const t = useTranslations();

  const handleBack = () => {
    router.push("/blog");
  };

  return (
    <button
      onClick={handleBack}
      className="inline-flex items-center gap-2 py-2 text-[18px] text-[#2A2A29] hover:text-[#000000]"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="rotate-180"
      >
        <path
          d="M9 18L15 12L9 6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {t("blog.allPosts")}
    </button>
  );
}
